import React from 'react';
import Icon from '@ant-design/icons';
import { ReactComponent as IconSettingsSvg }  from '../../assets/icons/icon_settings_blue.svg';

const SettingsIcon=(props)=>{
    return <Icon component={() => <IconSettingsSvg />} {...props}/>
}

export default SettingsIcon;